// src/ecrans/accueil/accueil-style.js — la feuille de style de l'Accueil NEST
// (maquette v819, « accueil moderne » : cartes, À décider en trois groupes,
// colonne de côté, Remplissage pleine largeur, cartes repliées au téléphone).
//
// Couleurs : vert = fait, bon ; aubergine = une action attend ; gris = neutre.
// Jamais d'orange, d'ambre ni de bleu ciel (la maquette en met sur « Urgent »,
// certaines icônes et les délais des voyageurs : ici, aubergine ou gris).
// Les plateformes gardent leurs couleurs (PLATEFORMES, exception voulue).

import { C, PLATEFORMES } from "../nest";

export const MICRO = (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
  </svg>
);

export const ICONES = {
  horloge: <><path d="M12 7v5l3 2" /><circle cx="12" cy="12" r="8.5" /></>,
  menage: <><path d="M4 20h16M7 20V9l5-4 5 4v11" /><path d="M10 20v-5h4v5" /></>,
  maison: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></>,
  incident: <><path d="M12 4l9 16H3z" /><path d="M12 10v4M12 17v.5" /></>,
  controle: <><circle cx="12" cy="12" r="3" /><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /></>,
  oeil: <><circle cx="12" cy="12" r="3" /><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z" /></>,
  msg: <path d="M4 5h16v11H8l-4 4z" />,
  tache: <><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></>,
  argent: <><path d="M7 3h7l4 4v14H7z" /><path d="M14 3v4h4M10 12h5M10 16h5" /></>,
  calendrier: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></>,
  feuille: <><path d="M5 19c0-8 6-14 14-14 0 8-6 14-14 14z" /><path d="M5 19l7-7" /></>,
};

/** La teinte d'une icône de ligne : aubergine = une action attend, vert = ménage, gris sinon. */
export const TEINTE = {
  horloge: "aub",
  incident: "aub",
  menage: "vert",
  maison: "gris",
  controle: "gris",
  oeil: "gris",
  msg: "gris",
};

export function IcBulle({ ic, petite }) {
  const t = TEINTE[ic] || "gris";
  return (
    <span className={`nacc-ic nacc-ic-${t}${petite ? " p" : ""}`} aria-hidden="true">
      <svg viewBox="0 0 24 24">{ICONES[ic] || ICONES.oeil}</svg>
    </span>
  );
}

const P = PLATEFORMES;

export const CSS_ACCUEIL = `
.nacc{display:grid;grid-template-columns:minmax(0,1.6fr) minmax(0,1fr);gap:18px;padding:18px 24px 60px;align-items:start}
.nacc-col{display:flex;flex-direction:column;gap:18px;min-width:0}
.nacc-full{grid-column:1/-1;min-width:0}
.nacc-carte{background:#fff;border-radius:22px;padding:22px;box-shadow:0 1px 0 rgba(23,33,30,.04),0 12px 32px -24px rgba(23,33,30,.35)}
.nacc-dec{background:#FBF5F9;box-shadow:0 0 0 1px ${C.aubBord}}
.nacc-hd{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;margin-bottom:14px}
.nacc-hd h3{margin:0;font-size:19px;font-weight:800;letter-spacing:-.01em;color:${C.encre}}
.nacc-hd p{margin:4px 0 0;font-size:13px;color:${C.gris}}
.nacc-lien{all:unset;box-sizing:border-box;flex:none;font-size:13px;font-weight:700;color:${C.vertF};cursor:pointer;padding:7px 12px;border-radius:999px;background:#fff;white-space:nowrap;box-shadow:0 0 0 1px ${C.bord}}
.nacc-lien:focus-visible,.nacc-go:focus-visible,.nacc-mic:focus-visible,.nacc-plus:focus-visible,.nacc-pli:focus-visible{outline:2px solid ${C.vert};outline-offset:2px}
.nacc-gt{display:flex;align-items:center;gap:8px;margin:10px 4px 6px;font-size:12px;font-weight:800;color:${C.gris}}
.nacc-gt em{font-style:normal;font-size:11px;border-radius:999px;padding:1px 8px;background:#fff;color:${C.gris}}
.nacc-g-urgent .nacc-gt,.nacc-g-aujourdhui .nacc-gt{color:${C.aub}}
.nacc-g-urgent .nacc-gt em,.nacc-g-aujourdhui .nacc-gt em{background:#fff;color:${C.aub}}
.nacc-list{display:flex;flex-direction:column;gap:6px}
.nacc-row{display:flex;align-items:center;gap:12px;padding:10px 10px;border-radius:14px;background:#fff;min-width:0}
.nacc-voy .nacc-row{background:transparent}
.nacc-ic{flex:none;width:38px;height:38px;border-radius:12px;display:flex;align-items:center;justify-content:center}
.nacc-ic.p{width:32px;height:32px;border-radius:10px}
.nacc-ic svg{width:19px;height:19px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
.nacc-ic-aub{background:${C.aubP};color:${C.aub}}
.nacc-ic-vert{background:${C.vertP};color:${C.vertF}}
.nacc-ic-gris{background:#EEF1F0;color:#3B4844}
.nacc-tx{flex:1;min-width:0}
.nacc-tx b{display:block;font-size:14.5px;font-weight:700;color:${C.encre};line-height:1.3}
.nacc-tx span{display:block;font-size:12.5px;color:${C.gris};margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.nacc-op{font-style:normal;font-weight:700;color:${C.vertF};background:${C.vertP};border-radius:999px;padding:1px 7px;font-size:11px;margin-right:4px}
.nacc-quand{flex:none;font-size:11.5px;font-weight:700;color:${C.aub};background:${C.aubP};border-radius:999px;padding:4px 9px;white-space:nowrap}
.nacc-voy .nacc-quand{color:#3B4844;background:#EEF1F0}
.nacc-mic{all:unset;box-sizing:border-box;flex:none;width:34px;height:34px;border-radius:50%;background:#F1F4F3;color:#3B4844;display:flex;align-items:center;justify-content:center;cursor:pointer}
.nacc-go{all:unset;box-sizing:border-box;flex:none;font-size:13px;font-weight:700;border-radius:999px;padding:9px 15px;background:${C.encre};color:#fff;cursor:pointer;white-space:nowrap}
.nacc-plus{all:unset;box-sizing:border-box;width:100%;font-size:13px;font-weight:700;color:${C.vertF};background:#fff;border-radius:12px;padding:10px 12px;cursor:pointer}
.nacc-vide{font-size:13px;color:${C.gris};margin:4px 2px}
.nacc-opl{all:unset;box-sizing:border-box;display:flex;align-items:center;gap:14px;width:100%;border-radius:22px;padding:18px 20px;background:${C.vertP};cursor:pointer}
.nacc-opl b{flex:1;font-size:14.5px;color:${C.encre}}
.nacc-lot{flex:none;width:44px;height:44px;border-radius:12px;background:#fff;color:${C.vert};display:flex;align-items:center;justify-content:center}
.nacc-lot svg{width:24px;height:24px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
.nacc-opgo{flex:none;font-size:13px;font-weight:700;color:#fff;background:${C.vert};border-radius:999px;padding:8px 14px}
.nacc-tk{all:unset;box-sizing:border-box;display:block;width:100%;padding:9px 8px;border-radius:12px;cursor:pointer}
.nacc-tk b{display:block;font-size:14px;font-weight:600;color:${C.encre}}
.nacc-tk small{display:block;font-size:12px;color:${C.gris}}
.nacc-tk.r small{color:${C.aub};font-weight:600}
.nacc-arg{background:${C.nuit};color:#fff}
.nacc-arg .nacc-hd h3{color:#fff}.nacc-arg .nacc-hd p{color:#BFD8CF}
.nacc-arg .nacc-lien{background:#24473F;color:#BFD8CF;box-shadow:none}
.nacc-tiles{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.nacc-t{border-radius:16px;padding:14px;background:#24473F}
.nacc-t small{display:block;font-size:12px;color:#BFD8CF;font-weight:600}
.nacc-t b{display:block;font-size:22px;font-weight:800;margin:4px 0 2px}
.nacc-t span{display:block;font-size:12px;color:#BFD8CF}
.nacc-big{display:flex;align-items:center;gap:14px;margin-bottom:16px}
.nacc-big b{font-size:40px;font-weight:800;letter-spacing:-.02em;color:${C.vertF};line-height:1;white-space:nowrap}
.nacc-big span{font-size:12.5px;color:${C.gris};line-height:1.4}
.nacc-rr{display:grid;grid-template-columns:260px minmax(0,1fr) 56px;gap:16px;align-items:center;padding:7px 4px}
.nacc-nm{font-size:13px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.nacc-nm small{display:block;font-size:11px;font-weight:500;color:${C.gris}}
.nacc-frise{display:grid;grid-template-columns:repeat(30,1fr);gap:2px;height:20px}
.nacc-frise i,.nacc-lg i{display:block;border-radius:2px;background:#E6EAE8}
.nacc-frise.ns i{background:repeating-linear-gradient(45deg,#F1F4F3,#F1F4F3 3px,#E6EAE8 3px,#E6EAE8 5px)}
.nacc-frise i.airbnb,.nacc-lg i.airbnb{background:${P.airbnb.bord}}
.nacc-frise i.booking,.nacc-lg i.booking{background:${P.booking.bord}}
.nacc-frise i.direct,.nacc-lg i.direct{background:${P.direct.bord}}
.nacc-frise i.ferme,.nacc-frise i.autre{background:#B9C2BF}
.nacc-pc{font-size:13px;font-weight:800;text-align:right}
.nacc-pc.nacc-bas{color:${C.aub}}
.nacc-lg{display:flex;flex-wrap:wrap;gap:6px 14px;font-size:11.5px;color:${C.gris};margin-top:10px}
.nacc-lg i{display:inline-block;width:10px;height:10px;margin-right:5px;vertical-align:-1px}
.nacc-pros{all:unset;box-sizing:border-box;display:flex;align-items:center;gap:12px;width:100%;margin-top:14px;padding:12px;border-radius:14px;background:#F6F8F7;cursor:pointer}
.nacc-pros .o{flex:none;font-size:13px;font-weight:700;color:${C.encre};padding:0 6px}
.nacc-ancien{all:unset;cursor:pointer;grid-column:1/-1;justify-self:end;font-size:13px;color:${C.gris};text-decoration:underline}
.nacc-pli{all:unset;box-sizing:border-box;display:flex;flex-direction:column;gap:10px;width:100%;cursor:pointer;background:#fff;border-radius:22px;padding:16px;box-shadow:0 1px 2px rgba(23,33,30,.06),0 0 0 1px rgba(23,33,30,.05);color:${C.encre}}
.nacc-pli-h{display:flex;align-items:center;gap:10px}
.nacc-pli-h b{flex:1;font-weight:800;font-size:15px}
.nacc-pli-c{width:26px;height:26px;border-radius:50%;background:rgba(23,33,30,.06);display:flex;align-items:center;justify-content:center;font-size:17px;color:${C.gris}}
.nacc-pli-big{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}
.nacc-pli-big b{font-size:28px;font-weight:800;letter-spacing:-.02em;line-height:1}
.nacc-pli-big span{font-size:12.5px;color:${C.gris}}
.nacc-pli-next{font-size:12.5px;color:#3B4744;background:rgba(23,33,30,.045);border-radius:10px;padding:8px 10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.nacc-pli.arg{background:${C.nuit};color:#fff}
.nacc-pli.arg .nacc-pli-big span,.nacc-pli.arg .nacc-pli-c{color:#BFD8CF}
.nacc-avs{display:flex;align-items:center;flex:none}
.nacc-av{width:30px;height:30px;border-radius:50%;color:#fff;background:${C.vertF};font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;box-shadow:0 0 0 2px #fff}
.nacc-av+.nacc-av{margin-left:-8px}
.nacc-av:nth-child(2){background:${C.aub}}.nacc-av:nth-child(3){background:${C.gris}}
.nacc-spark{display:flex;align-items:flex-end;gap:2px;height:38px}
.nacc-spark i{flex:1;background:${C.vertF};border-radius:2px 2px 0 0;min-height:2px}
.nacc-spark i.nacc-bas{background:${C.aub}}
.nacc-replier{all:unset;cursor:pointer;flex:none;font-size:12px;font-weight:700;background:#F1F4F3;color:#3B4844;border-radius:999px;padding:6px 10px}
.nacc-arg .nacc-replier{background:#24473F;color:#BFD8CF}
@media (max-width:900px){.nacc{grid-template-columns:1fr}.nacc-rr{grid-template-columns:minmax(0,1fr) 110px 42px;gap:10px}}
@media (max-width:640px){
 .nacc{padding:12px 12px 40px;gap:12px}.nacc-col{gap:12px}
 .nacc-carte{padding:16px;border-radius:18px}
 .nacc-hd{flex-wrap:wrap}.nacc-dec .nacc-hd p{display:none}
 .nacc-quand,.nacc-mic{display:none}
 .nacc-row{padding:9px 6px;gap:10px}
 .nacc-dec .nacc-row .nacc-tx b{display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;font-size:14px}
 .nacc-dec .nacc-go{width:34px;height:34px;padding:0;border-radius:50%;font-size:0;display:flex;align-items:center;justify-content:center}
 .nacc-dec .nacc-go::after{content:'›';font-size:20px;line-height:1;margin-top:-2px}
 .nacc-g-attendre .nacc-go{background:${C.gris}}.nacc-g-urgent .nacc-go,.nacc-g-aujourdhui .nacc-go{background:${C.aub}}
 .nacc-dec .nacc-op{display:none}
 .nacc-opl{padding:12px 14px}
 .nacc-rr{grid-template-columns:minmax(0,1fr) 90px 38px;gap:10px}
 .nacc-frise{gap:1px;height:16px}
 .nacc-big b{font-size:32px}
}
`;
